const LOGOUT_MINUTES = 30;
const WARNING_MINUTES = 3;

export const MINUTE = 60 * 1000;
export const INACTIVE_TIME_ALLOWED = LOGOUT_MINUTES * MINUTE;
export const INACTIVE_WARNING_TIME = (LOGOUT_MINUTES - WARNING_MINUTES) * MINUTE;
